<template>
  <footer class="relative bg-navy-900 text-white border-t-4 border-primary-500">
    <div class="absolute inset-0 bg-grid-pattern opacity-[0.05] pointer-events-none"></div>

    <div class="relative container-app py-14 md:py-20">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">

        <!-- Brand -->
        <div class="md:col-span-2">
          <div class="inline-block bg-white rounded-2xl px-4 py-3 mb-6 shadow-xl">
            <img src="/aps.png" alt="APS Expertos en Pensiones" class="h-14 w-auto" />
          </div>
          <p class="text-white/75 text-base md:text-lg leading-relaxed max-w-md mb-6">
            Asesoría personalizada para que cada trabajador alcance una pensión digna y un retiro tranquilo. Te acompañamos en cada paso, con claridad y confianza.
          </p>
          <div class="flex flex-wrap gap-2">
            <span v-for="v in ['Confianza','Experiencia','Resultados']" :key="v"
                  class="px-3 py-1.5 border border-primary-500/30 rounded-full text-primary-200 text-xs">
              <span class="inline-block w-1.5 h-1.5 bg-primary-500 rounded-full mr-2 align-middle"></span>{{ v }}
            </span>
          </div>

          <!-- Redes sociales -->
          <div class="mt-7">
            <h4 class="text-primary-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">Síguenos</h4>
            <div class="flex flex-wrap gap-3">
              <a v-for="r in redes" :key="r.label"
                 :href="r.href" target="_blank" rel="noopener noreferrer"
                 :aria-label="r.label"
                 class="w-10 h-10 rounded-full flex items-center justify-center border border-white/15 text-white/70 hover:text-white hover:bg-primary-500 hover:border-primary-500 transition-all duration-200">
                <span v-html="r.icon"></span>
              </a>
            </div>
          </div>
        </div>

        <!-- Servicios -->
        <div>
          <h4 class="text-primary-500 text-xs font-bold uppercase tracking-[0.2em] mb-5">Servicios</h4>
          <ul class="space-y-2.5">
            <li v-for="s in servicios" :key="s" class="text-white/60 text-sm hover:text-primary-200 transition-colors cursor-default flex items-start gap-2">
              <span class="text-primary-500/60 mt-0.5">›</span>{{ s }}
            </li>
          </ul>
        </div>

        <!-- Contacto -->
        <div>
          <h4 class="text-primary-500 text-xs font-bold uppercase tracking-[0.2em] mb-5">Contacto</h4>
          <div class="space-y-4 text-sm">
            <a href="tel:+5215643127214" class="flex items-start gap-3 text-white/70 hover:text-primary-200 transition-colors">
              <svg class="w-4 h-4 mt-0.5 text-primary-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.515l.715 2.86a2 2 0 01-.45 1.95l-1.27 1.27a16 16 0 006.586 6.586l1.27-1.27a2 2 0 011.95-.45l2.86.715A2 2 0 0121 18.72V21a2 2 0 01-2 2C10.163 23 1 13.837 1 3a2 2 0 012-2"/></svg>
              <span>56 4312 7214</span>
            </a>
            <a href="https://maps.google.com/?q=Ignacio+Ramirez+Tabacalera+CDMX" target="_blank" rel="noopener" class="flex items-start gap-3 text-white/70 hover:text-primary-200 transition-colors">
              <svg class="w-4 h-4 mt-0.5 text-primary-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/></svg>
              <span>Ignacio Ramírez s/n, Local 1<br>Col. Tabacalera, CDMX 06030</span>
            </a>
            <div class="flex items-start gap-3 text-white/70">
              <svg class="w-4 h-4 mt-0.5 text-primary-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke-width="1.8"/><path stroke-linecap="round" stroke-width="1.8" d="M12 7v5l3 2"/></svg>
              <span>Lun – Vie · 9:00 a 18:00</span>
            </div>
            <a href="https://wa.me/5215643127214?text=Hola%20APS%2C%20quiero%20informaci%C3%B3n%20sobre%20mi%20pensi%C3%B3n."
               target="_blank" rel="noopener"
               class="inline-flex items-center gap-2 mt-2 px-5 py-2.5 rounded-full bg-primary-500 text-primary-900 text-xs font-bold uppercase tracking-wider hover:bg-primary-200 transition-colors">
              Solicita tu asesoría
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="relative border-t border-white/10">
      <div class="container-app py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p class="text-white/40 text-xs">&copy; {{ year }} APS — Asesoría Personalizada en Pensiones. Todos los derechos reservados.</p>
        <p class="text-white/30 text-xs italic font-display">Tu Futuro, Nuestra Estrategia.</p>
      </div>
    </div>
  </footer>
</template>

<script>
// Iconos SVG monocromos de cada red — inline para no agregar dependencias
const ICON_TIKTOK = '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>';
const ICON_FB = '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>';
const ICON_IG = '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>';
const ICON_LI = '<svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>';

export default {
  name: 'TheFooter',
  data() {
    return {
      year: new Date().getFullYear(),
      servicios: [
        'Cálculo de pensión IMSS',
        'Semanas no reconocidas',
        'Recuperación INFONAVIT',
        'Recuperación SAR / AFORE',
        'Corrección de datos IMSS',
        'Estrategias de retiro',
        'Crédito de pensión'
      ],
      redes: [
        { label: 'TikTok',    href: 'https://www.tiktok.com/@yanelifigueroa_aps',                              icon: ICON_TIKTOK },
        { label: 'Facebook',  href: 'https://www.facebook.com/share/14dbx19ikjh/',                              icon: ICON_FB },
        { label: 'Instagram', href: 'https://www.instagram.com/yaneli.aps/',                                    icon: ICON_IG },
        { label: 'LinkedIn',  href: 'https://www.linkedin.com/in/aps-experto-enpensiones-12774b410/',           icon: ICON_LI },
      ]
    };
  }
};
</script>
